import { Loading } from '@saesa/ui-kit-front';
import {
  EMISION_BOLETA,
  EMITIDA,
  ENTREGADA,
  ENTREGA_BOLETA,
  EN_PREPARACION,
  EN_PROCESO,
  EXITO,
  NO_ENTREGADA,
  PAGADA,
  POR_VENCER,
  SIN_EXITO,
  TOMA_LECTURA,
  VENCIMIENTO_BOLETA,
} from 'navigation';
import { lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';

const RouterConfig = ({ path }: { path: string }) => {
  const CicloFacturacion = lazy(() => import('pages/CicloFacturacion/CicloFacturacion'));
  const TomaLecturaEnPreparacion = lazy(
    () => import('pages/CicloFacturacion/TomaLectura/TomaLecturaEnPreparacion/TomaLecturaEnPreparacion')
  );
  const TomaLecturaEnTomaLectura = lazy(() => import('pages/CicloFacturacion/TomaLectura/EnTomaLectura/EnTomaLectura'));
  const TomaLecturaLecturaExitosa = lazy(() => import('pages/CicloFacturacion/TomaLectura/LecturaExitosa/LecturaExitosa'));
  const TomaLecturaLecturaNoExitosa = lazy(() => import('pages/CicloFacturacion/TomaLectura/LecturaNoExitosa/LecturaNoExitosa'));
  const EmisionBoletaEnPreparacion = lazy(() => import('pages/CicloFacturacion/EmisionBoleta/EmisionEnPreparacion/EmisionEnPreparacion'));
  const EntregaBoletaEmitida = lazy(() => import('pages/CicloFacturacion/EntregaBoleta/BoletaEmitida/BoletaEmitida'));
  const VencimientoBoletaEntregada = lazy(() => import('pages/CicloFacturacion/VencimientoBoleta/BoletaEntregada/BoletaEntregada'));
  const VencimientoBoletaNoEntregada = lazy(() => import('pages/CicloFacturacion/VencimientoBoleta/BoletaNoEntregada/BoletaNoEntregada'));
  const VencimientoBoletaPorVencer = lazy(() => import('pages/CicloFacturacion/VencimientoBoleta/BoletaPorVencer/BoletaPorVencer'));
  const VencimientoBoletaPagada = lazy(() => import('pages/CicloFacturacion/VencimientoBoleta/BoletaPagada/BoletaPagada'));

  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route exact path={path}>
          <CicloFacturacion />
        </Route>
        <Route path={`${path}/${TOMA_LECTURA}/${EN_PREPARACION}`}>
          <TomaLecturaEnPreparacion />
        </Route>
        <Route path={`${path}/${TOMA_LECTURA}/${EN_PROCESO}`}>
          <TomaLecturaEnTomaLectura />
        </Route>
        <Route path={`${path}/${TOMA_LECTURA}/${EXITO}`}>
          <TomaLecturaLecturaExitosa />
        </Route>
        <Route path={`${path}/${TOMA_LECTURA}/${SIN_EXITO}`}>
          <TomaLecturaLecturaNoExitosa />
        </Route>
        <Route path={`${path}/${EMISION_BOLETA}/${EN_PREPARACION}`}>
          <EmisionBoletaEnPreparacion />
        </Route>
        <Route path={`${path}/${ENTREGA_BOLETA}/${EMITIDA}`}>
          <EntregaBoletaEmitida />
        </Route>
        <Route path={`${path}/${VENCIMIENTO_BOLETA}/${ENTREGADA}`}>
          <VencimientoBoletaEntregada />
        </Route>
        <Route path={`${path}/${VENCIMIENTO_BOLETA}/${NO_ENTREGADA}`}>
          <VencimientoBoletaNoEntregada />
        </Route>
        <Route path={`${path}/${VENCIMIENTO_BOLETA}/${POR_VENCER}`}>
          <VencimientoBoletaPorVencer />
        </Route>
        <Route path={`${path}/${VENCIMIENTO_BOLETA}/${PAGADA}`}>
          <VencimientoBoletaPagada />
        </Route>
      </Switch>
    </Suspense>
  );
};

export default RouterConfig;
